import { render, staticRenderFns } from "./BusinessOmniplayEventsOrderSimple.vue?vue&type=template&id=7464fe66"
import script from "./BusinessOmniplayEventsOrderSimple.vue?vue&type=script&lang=js"
export * from "./BusinessOmniplayEventsOrderSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports